import { Text } from "@wojo/ui";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import React from "react";
import { getCurrency } from "../../../../hooks";
import { useTripBuilder } from "../context/TripBuilderContext";
import { useTripBuilderQuote } from "../context/TripBuilderQuoteStepContext";
import { formatDepartureStartAndEndDates } from "../hooks/format-departure-start-and-end-dates";
import styles from "./TripBuilderQuoteStep.module.scss";
dayjs.extend(utc);

export const QuoteGroupsDepartureDateAndPrice: React.FC = () => {
    const { gcDeparture } = useTripBuilder();
    const { draftQuote, rolledUpTourPrice } = useTripBuilderQuote();
    const { formatCurrency } = getCurrency();

    if (!gcDeparture) {
        return null;
    }
    return (
        <Text.Body emphasis="2" className={styles.date}>
            <span
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "var(--g-spacing-sm)",
                }}
            >
                {formatDepartureStartAndEndDates(
                    draftQuote?.order.trips.at(0)?.departureDate,
                    draftQuote?.order.trips.at(0)?.endDate,
                )}
            </span>
            {!!rolledUpTourPrice && formatCurrency(rolledUpTourPrice)}
        </Text.Body>
    );
};
